<template>
    <div class="row">
        <div class="col-lg-1 col-md-3 col-sm-6">
            <label>{{this.label}}:</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">
            Days:
            <date-picker valueType="format" @input="daysValue" :editable="true">
                <div slot="input">
                    <input type="text" class="form-control" v-model="days" style="width: 60px;">
                </div>
                <div slot="icon-calendar">
                    <i class="fa fa-sort" aria-hidden="true" style="color: #292929"></i>
                </div>
            </date-picker>

        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">
            Month:
            <date-picker type="month" @input="monthsValue" :editable="true">
                <div slot="input">
                    <input type="text" class="form-control" v-model="month" style="width: 60px;">
                </div>
                <div slot="icon-calendar">
                    <i class="fa fa-sort" aria-hidden="true" style="color: #292929"></i>
                </div>
            </date-picker>

        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">
            Year:
            <date-picker type="year" @input="yearValue" :editable="true">
                <div slot="input">
                    <input type="text" class="form-control" v-model="year" style="width: 60px;">
                </div>
                <div slot="icon-calendar">
                    <i class="fa fa-sort" aria-hidden="true" style="color: #292929"></i>
                </div>
            </date-picker>

        </div>

    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    export default {
        name: "datepicker",
        components: {DatePicker},
        props:['label'],
        data() {
            return {
                days: null,
                month: null,
                year: null,

            };
        },
        methods: {
            daysValue(el) {
                var date = new Date(el),
                    // mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                console.log(day);
                this.days = day;
            },
            monthsValue(el){
                var date = new Date(el),
                     mnth = ("0" + (date.getMonth() + 1)).slice(-2);
                    //day = ("0" + date.getDate()).slice(-2);
                this.month = mnth;
            },
            yearValue(el){
                var date=new Date(el),
                    year = ("0" + (date.getFullYear())).slice(-2);
                this.year=year;
            }
        }

    }
</script>

<style scoped>
    .mx-input {
        display: none !important;
    }
    .mx-datepicker{
        width: 60px !important;
    }
    .form-control, .input-group-text {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }
</style>
